module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\">\r\n    <g fill=\"#2D2D2D\" fill-rule=\"evenodd\">\r\n        <path fill-rule=\"nonzero\" d=\"M18 4.667L16 2H4L2 4.667V18h16V4.667zM0 4l3-4h14l3 4v16H0V4z\"/>\r\n        <path d=\"M0 4h20v2H0z\"/>\r\n        <path d=\"M9 1.111h2v4H9z\"/>\r\n    </g>\r\n</svg>\r\n"


//////////////////
// WEBPACK FOOTER
// ./template/styles/icons/orders.svg
// module id = ./template/styles/icons/orders.svg
// module chunks = client.sitechrome